import { realApi } from './api';

// Composición de cada participante (equipo en dobles, jugador en
// individual), con orden y estado. Solo jugadores en activo (fecha_baja IS
// NULL). Lo usa Actas.js para el selector de "quién jugó", y las pantallas
// de gestión de equipos.
export const getParticipantesReal = (temporadaId, modalidad) => {
  const params = modalidad ? `?modalidad=${encodeURIComponent(modalidad)}` : '';
  return realApi
    .get(`/temporadas/${encodeURIComponent(temporadaId)}/participantes${params}`)
    .then((r) => r.datos);
};

export const crearParticipante = (temporadaId, datos) =>
  realApi.post(`/temporadas/${encodeURIComponent(temporadaId)}/participantes`, datos);

export const actualizarParticipante = (participanteId, datos) =>
  realApi.patch(`/participantes/${participanteId}`, datos);

export const borrarParticipante = (participanteId) =>
  realApi.delete(`/participantes/${participanteId}`);

// ids en el orden final deseado: el backend asigna orden = índice + 1.
export const reordenarParticipantes = (temporadaId, modalidad, ids) =>
  realApi.put(`/temporadas/${encodeURIComponent(temporadaId)}/participantes/orden`, { modalidad, ids });
